import { DateTime } from 'luxon';
import type { GanttItem } from '@/modules/viewer/types/gantt-item.type.ts';
import type { GanttItemDto } from '@/modules/viewer/dto/gantt-item.dto.ts';

export class GanttItemAdapter {
  private static map(response: GanttItemDto): GanttItem {
    return {
      tableId: response['TABLE_ID'],
      parentId: response['PARENT_ID'],
      id: response['RP_ID'],
      type: response['RPT_ID'],
      status: response['RPS_ID'],
      parents: response['PARENTS'],
      links: response['LINKS'],
      documentId: response['DOC_ID'],
      content: response['Описание'],
      comment: response['Примечание'],
      deadline: DateTime.fromSQL(response['Срок']),
      number: response['Номер'],
      executor: response['Исполнитель'],
      executorId: response['LOGIN_ID'],
    };
  }

  static mapList(response: GanttItemDto[]) {
    return response.map(GanttItemAdapter.map);
  }
}
